import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { ConstantService } from "../../../components/common/utils/constant.service";
import { Cliente, UsuarioVamTit } from "../../login/cliente_login";
import { SessionStorageService } from "ngx-webstorage";
import { PolizaEntity } from '../../empresas/entities/polizas_cliente_entity';
import { SiniestrosVamTit, SiniestroVam, VamTitularEntity } from '../titulares/entities/vam_titulares_entity';
import { TipRcl, InfoPoliza, Reclamo, DiagnosticoEntity } from '../vam_entity';

declare var jQuery: any;
@Injectable()
export class VamTitularesPolizasService {
  usuario: ClienteLogin;
  private url = "vamTittular";
  constate: String;

  constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService, public http : Http) {
    let constantService = new ConstantService();
    this.url = constantService.API_ENDPOINT + this.url;
    this.constate = constantService.API_ENDPOINT;
  }
  ConsultarPolizasVamTitular(usuarioVamTit: UsuarioVamTit): Observable<PolizaEntity[]> {
    let body = JSON.stringify(usuarioVamTit);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/consultarPolVamTit", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  ConsultarRedesVamTitular(poliza: PolizaEntity): Observable<any> {
    let body = JSON.stringify(poliza);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/consultarRedesVam", body, options).map(this.extractData)
      .catch(this.handleError);
  }
  ConsultarPlanes(poliza: PolizaEntity): Observable<any> {
    let body = JSON.stringify(poliza);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/consultarPlanesVam", body, options).map(this.extractData)
      .catch(this.handleError);
  }
  ConsultarSiniestros(poliza: PolizaEntity): Observable<any> {
    let body = JSON.stringify(poliza);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/consultarSiniestrosVamTit", body, options).map(this.extractData)
      .catch(this.handleError);
  }
  ConsultarDependientesVam(poliza: PolizaEntity): Observable<any> {
    let body = JSON.stringify(poliza);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/consultarDependientesTitVam", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  GetTipoReclamo(tipNeg: number, ramCod: string): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/TiposReclamosVam/" + tipNeg + "/" + ramCod, options).map(this.extractData)
      .catch(this.handleError);
  }
  GetVamTitular(cliente: ClienteLogin): Observable<any>{
    let body = JSON.stringify(cliente);
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/consultarVamTit", body, options).map(this.extractData)
      .catch(this.handleError);
  }
  GetUriVam():Observable<any>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/GetUriVam/", options).map(this.extractData)
      .catch(this.handleError);
  }
  GetTipoDocumentosParaRclByAseguradora(aseCod: number, tipCod: number):Observable<any>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/GetDocumentos/" + aseCod + "/" + tipCod, options).map(this.extractData)
      .catch(this.handleError);
  }
  ConsultarDependientes(consulta: InfoPoliza): Observable<any> {
    let body = JSON.stringify(consulta);
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.post(this.url + "/ConsultaDependientes", body, options).map(this.extractData)
      .catch(this.handleError);
  }
  GetFormularioPath(aseCod: number):Observable<any>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/GetFormulario/" + aseCod + "/", options).map(this.extractData)
      .catch(this.handleError);
  }

  GetGuardarReclamo(reclamo: FormData):Observable<any>{
    let body = JSON.stringify(reclamo);
    let headers = new Headers({ 'Content-Type': 'application/form-data', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.url + "/GetGuardarReclamo", body, options).map(this.extractData)
      .catch(this.handleError);
  }

  GetDiagnosticos():Observable<DiagnosticoEntity[]>{
    let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': "Token " + sessionStorage.getItem("Token") });
    let options = new RequestOptions({ headers: headers });
    return this.authHttp.get(this.url + "/getDiagnosticosVAM/", options).map(this.extractData)
      .catch(this.handleError);
  }
  getAdjuntoSiniestro(siniestro: SiniestroVam): Observable<any> {
    let body = JSON.stringify(siniestro);
    let headers = new Headers({
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    return this.authHttp.post(this.url + "/DescargaAdjuntosTrackingpagados/", body, options)
        .map(response => response).catch(this.handleError);

}
  private extractData(res: Response) {
    let body = res.json();
    return body || {};
  }
  private handleError(error: any) {
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/polizas/vam-titulares-polizas.service.ts